export const assertDefined = <X>(item: X, msg: string) => {
  if (item === undefined) throw new Error(msg)
  return item as Exclude<X, undefined>
}

export const assertNonNullable = <X>(item: X, msg: string) => {
  if (!item) throw new Error(msg)
  return item as NonNullable<X>
}
